<template>
  <div>
    <b-card>
    <b-container >
      <!--b-row>
        <b-col col sm="4">
          <h3>Login</h3>
        </b-col>
      </b-row-->
      <b-row>
        <b-col col sm ="12" class = "my-3">
          
          <img
          
          src="../../assets/LogoTightCrop.gif"
          height="60"
          width="170"
          
          alt="YI Logo"
        />
        </b-col>
      </b-row>
      
      <b-row >
        <b-col col sm="5" class = "my-3">
         <h5> You need to login to use this site</h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col col sm="1">
           <b-button variant="outline-primary" @click="login()">Login</b-button>
        </b-col>
        <b-col col sm="1">
           
        </b-col>
        <b-col col sm="1">
          <b-button variant="outline-primary" @click="logout()" >Logout</b-button> 
        </b-col>
      </b-row>
    </b-container>
    </b-card>



    
  </div>
</template>

<script>
import axios from "axios";
//import {stateForRestore} from  "../../store/initialState";
export default {
  computed: {
    urlPrefix() {
      return this.$store.getters.urlPrefix;
    },
  },
  mounted: function() {
    // we want to see if we have a valid django token in local storage
    // if we have do nothing user probably wants to logout
    // else call login
    const expiryDate = new Date(
      localStorage.getItem("djangoAccessTokenExpiry")
    );
    // No token or token expired
    if (new Date() > expiryDate) {
      this.login();
    }
  },
  data() {
    return {
      testData: "simon",
      isSignIn: null,
      authResponse: null,
      userProfile: null,
    };
  },

  methods: {
    login() {
      this.$gAuth
        .signIn()
        .then((GoogleUser) => {
          // On success do something, refer to https://developers.google.com/api-client-library/javascript/reference/referencedocs#googleusergetid
          //eslint-disable-next-line no-console
          //console.log("user", GoogleUser);
          //eslint-disable-next-line no-console
          //cosole.log('GoogleUser',GoogleUser);
          this.userProfile = GoogleUser.getBasicProfile(); // Get the user's unique ID string.
          //eslint-disable-next-line no-console
          //cosole.log('GoogleUserName ',this.userProfile.getName());
          // GoogleUser.getBasicProfile() : Get the user's basic profile information.
          this.authResponse = GoogleUser.getAuthResponse(); // Get the response object from the user's auth session. access_token and so on
          //eslint-disable-next-line no-console
          //console.log(this.authResponse)
          this.isSignIn = this.$gAuth.isAuthorized;
          //this.exchangeTokens(GoogleUser.tc.access_token);
          this.exchangeTokens(this.authResponse.access_token);
        })
        .catch((error) => {
          //eslint-disable-next-line no-console
          console.log("google log in error", error);
          //eslint-disable-next-line no-console
          //cosole.log(error);
          //on fail do something
        });
    },
    exchangeTokens(gtoken) {
      // sends token to django app and exchanges it for an access token to continue on the app
      const postUrl = this.urlPrefix + "auth/convert-token";
      const data = {
        client_id: "Eleu06MeWuuGFoabDAIYENFgUriYuHQRnCeppRCs",
        token: gtoken,
        backend: "google-oauth2",
        client_secret: "",
        grant_type: "convert_token",
      };
      axios
        .post(postUrl, data)
        .then((result) => {
          //eslint-disable-next-line no-console
          //console.log(result);
          // send token to cookie jar and store
          this.$store.dispatch("djangoToken", result.data);
          this.saveToken(result.data);

          return;
        })
        .catch((error) => {
          //eslint-disable-next-line no-console
          console.log(error);
          return;
        });
    },

    saveToken(djangoToken) {
      // takes the token granted by django and stores it local storage
      // then also stores the expiry time.
      const cookieName = "djangoAccessToken";
      //expiry time in ms
      const expiryTime = djangoToken.expires_in * 1000;
      const content = djangoToken.access_token;
      const d = new Date();
      d.setTime(d.getTime() + expiryTime);
      const expireTimeString = d.toUTCString();
      //var expires = "expires=" + expireTimeString;
      //eslint-disable-next-line no-console
      //cosole.log(expires);
      // add success tokens and expiry time to local storage.
      localStorage.setItem(cookieName, content);
      localStorage.setItem("djangoAccessTokenExpiry", expireTimeString);
      localStorage.setItem("userName", this.userProfile.getName());
      // finally navigate to home or sign in
      if (this.userProfile.Bd == "Signin User") {
        this.$router.push("/signin");
      } else {
        this.$router.push("/");
      }
    },

    logout() {
      const cookieName = "djangoAccessToken";
      const postUrl = this.urlPrefix + "auth/invalidate-sessions";
      const fd = new FormData();
      //const data = {client_id: "Eleu06MeWuuGFoabDAIYENFgUriYuHQRnCeppRCs",};
      fd.append("client_id", "Eleu06MeWuuGFoabDAIYENFgUriYuHQRnCeppRCs");
      const djangoToken = localStorage.getItem(cookieName);
      const headers = { headers: { Authorization: "Bearer " + djangoToken } };
      axios
        .post(postUrl, fd, headers)
        .then(() => {
          //eslint-disable-next-line no-console
          //cosole.log(result);
          // send token to cookie jar and store
          this.$store.dispatch("djangoToken", {});
          this.removeToken();
          location.reload()
          //this.$store.replaceState(stateForRestore)
          //this.$store.dispatch("resetStore");

          return;
        })
        .catch((error) => {
          //eslint-disable-next-line no-console
          console.log(error);
          location.reload()
          //this.$store.replaceState(stateForRestore)
          return;
        });
    },

    removeToken() {
      // deletes the authentication data and expiry time from local storage
      const cookieName = "djangoAccessToken";
      localStorage.removeItem(cookieName);
      localStorage.removeItem("djangoAccessTokenExpiry");
    },

    findMeACookie(cookieName) {
      var cookies = document.cookie;
      //console.log(cookies);
      // convert cookies to an array splitting on the semi colon
      const cookieArray = cookies.split(";");
      //eslint-disable-next-line no-console
      //console.log(cookieArray);
      // ammend name to find it including = sign
      cookieName = cookieName + "=";
      //itterate over array and pull out cookie
      for (var i = 0; i < cookieArray.length; i++) {
        var element = cookieArray[i];
        //eslint-disable-next-line no-console
        //console.log(element);
        // for some strange reason subsequent cookies have spaces prefixing their name
        // If they do snip it off
        while (element.charAt(0) == " ") {
          element = element.substring(1);
        }

        if (element.indexOf(cookieName) == 0) {
          const cookieContent = element.slice(
            cookieName.length,
            element.length
          );
          return cookieContent;
        }
      }
      return null;
    },
  },
};
</script>
<style scoped></style>
